if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.bindOnItemClick = this.onItemClick.bind(this);
        this.bindOnMediaClick = this.onMediaClick.bind(this);
        this.bindSetMediaHorizontalScroll = this.setMediaHorizontalScroll.bind(this);

        this.isFirstShow = true;

        this.slider = this.querySelector('component-slider');
        this.itemList = this.querySelector('.slider__list');
        this.items = Array.from(this.querySelectorAll('.product-media-modal__item'));
        this.medias = Array.from(this.querySelectorAll('.product-media-modal__media--zoom'));

        this.items.forEach((item) => {
          item.addEventListener('click', this.bindOnItemClick);
          if (item.querySelector('.product-media-modal__media--zoom')) {
            item.addEventListener('wheel', this.bindSetMediaHorizontalScroll);
          }
        })

        if (!this.itemList || !this.hasAttribute('enable-click')) return;
        this.medias.forEach((media) => {
          media.addEventListener('click', this.bindOnMediaClick)
        })
      }

      connectedCallback() {
        super.connectedCallback();
      }

      hide() {
        super.hide();
        this.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        const mediaId = opener.dataset.mediaId;
        if (!mediaId) return;
        if (this.isFirstShow) {
          this.resetSlider();
          this.isFirstShow = false;
        }
        requestAnimationFrame(() => {
          this.setMediaZoom();
          this.showActiveMedia(mediaId);
        });
      }

      showActiveMedia(mediaId) {
        const media = this.items.find(element => element.dataset.mediaId == mediaId);
        if (!media || !this.slider) return;

        this.slider.navigateToSlide(+media.dataset.index, false);

        return;
      }

      onItemClick(event) {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model, img, video, .product-media-modal__media'))
          this.hide();
      }

      onMediaClick(event) {
        const parent = event.currentTarget.parentElement;
        const parentRect = parent.getBoundingClientRect();
        const relativeX = event.clientX - parentRect.left;
        const relativeY = event.clientY - parentRect.top;
        const horizontalPosition = relativeX / parentRect.width;
        const verticalPosition = relativeY / parentRect.height;

        parent.classList.toggle('media-zoom');

        // Changes parent scroll to match the mouse click position
        requestAnimationFrame(() => {
          const horizontalScrollSpace = parent.scrollWidth - parentRect.width;
          const verticalScrollSpace = parent.scrollHeight - parentRect.height;

          const horizontalScroll = horizontalScrollSpace * horizontalPosition;
          const verticalScroll = verticalScrollSpace * verticalPosition;

          parent.scrollTo({ left: horizontalScroll, top: verticalScroll })
        })
      }

      setActiveVariantMedia(id, prepend) {
        const media = this.items.find(element => element.dataset.mediaId == id);
        if (!media || media.classList.contains('is-active')) return;

        this.items.forEach(media => {
          media.classList.remove('is-active');
        });
        media.classList.add('is-active');

        const container = this.querySelector('.slider__list');
        if (prepend == true && container) {
          container.insertBefore(media, this.items[0]);
          requestAnimationFrame(() => {
            this.resetSlider();
          })
        }
      }

      setMediaZoom() {
        this.medias.forEach(media => {
          const mediaRatio = +media.dataset.ratio;
          const containerRatio = media.parentElement.getBoundingClientRect().width / media.parentElement.getBoundingClientRect().height
          media.classList.remove('vertical-zoom', 'horizontal-zoom');

          if (mediaRatio < containerRatio) media.classList.add('vertical-zoom');
          else if (mediaRatio > containerRatio) media.classList.add('horizontal-zoom');
        })
      }

      setMediaHorizontalScroll(event) {
        event.currentTarget.scrollLeft += event.deltaY * 0.5;
      }

      resetSlider() {
        if (!this.slider) return;

        this.slider.removeEventListeners();
        this.slider.setUpSlider();
      }

      pauseAllMedia() {
        this.querySelectorAll('.js-youtube').forEach((video) => {
          video.contentWindow.postMessage('{"event":"command","func":"getPlayerState","args":""}', '*');
          window.addEventListener('message', (event) => {
            if (event.data === 1) {
              video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }
          });
        });

        this.querySelectorAll('.js-vimeo').forEach((video) => {
          if (typeof Vimeo == 'undefined') return;
          const player = new Vimeo.Player(video);
          if (!player) return;
          player.getPaused().then((paused) => {
            if (!paused) {
              player.pause();
            }
          });
        });

        this.querySelectorAll('video').forEach((video) => {
          if (!video.paused) {
            video.pause();
          }
        });

        this.querySelectorAll('product-model').forEach((model) => {
          if (model.modelViewerUI && model.modelViewerUI.playing) {
            model.modelViewerUI.pause();
          }
        });
      }
    }
  );
}
